<script setup lang="ts" generic="T">
type Breakpoint = "base" | "sm" | "md" | "lg" | "xl";
type Cols = 1 | 2 | 3;

withDefaults(
  defineProps<{
    items: T[];
    itemKey?: (item: T, index: number) => string | number;
    label?: string;
    slideLabel?: (index: number, total: number) => string;
    cols?: Cols | Partial<Record<Breakpoint, Cols>>;
    overflowVisible?: boolean | "sm" | "md" | "lg" | "xl";
  }>(),
  { cols: () => ({ base: 1, sm: 2, lg: 3 }) }
);

defineSlots<{
  default(props: { item: T; index: number }): unknown;
  baseline(props: { selectedIndex: number; scrollSnaps: number[] }): unknown;
}>();
</script>

<template>
  <AppCarousel
    :items="items"
    :item-key="itemKey"
    :label="label"
    :slide-label="slideLabel"
    :cols="cols"
    class="[--carousel-gap:--spacing(2.5)]"
    :overflow-visible="overflowVisible"
  >
    <template #default="slotProps">
      <slot v-bind="slotProps" />
    </template>
    <template #baseline="baselineProps">
      <slot name="baseline" v-bind="baselineProps" />
    </template>
  </AppCarousel>
</template>
